import { ghostBtnClass, inputClass } from "@/components/common/surfaceClasses";
import { QUALITY_PAGE_SIZES, type QualityPageSize } from "@/components/audience-data/audienceDataFormat";

export function AudienceDataPager(props: {
  page: number;
  pages: number;
  pageSize: QualityPageSize;
  setPage: (n: number) => void;
  setPageSize: (n: QualityPageSize) => void;
}) {
  return (
    <div className="flex min-w-0 flex-wrap items-center gap-2 text-sm text-gray-700 dark:text-zinc-300">
      <label className="flex items-center gap-2">
        Rows
        <select
          className={inputClass}
          value={props.pageSize}
          onChange={(e) => {
            props.setPageSize(Number(e.target.value) as QualityPageSize);
            props.setPage(1);
          }}
        >
          {QUALITY_PAGE_SIZES.map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
      </label>
      <span>
        {props.page} of {props.pages}
      </span>
      <button
        type="button"
        className={ghostBtnClass}
        disabled={props.page <= 1}
        onClick={() => props.setPage(props.page - 1)}
      >
        Previous
      </button>
      <button
        type="button"
        className={ghostBtnClass}
        disabled={props.page >= props.pages}
        onClick={() => props.setPage(props.page + 1)}
      >
        Next
      </button>
    </div>
  );
}
